import React from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { Text } from 'components/typography/Text';
import { useMultiGrid } from 'services/multi-grid/hook';
import { FocusableElement } from 'components/FocusableElement';

export const MultiGridItem = ({ grid }) => {
  const { selectedGrid, setMultiGrid } = useMultiGrid();

  return (
    <FocusableElement
      className={classNames(
        styles.item,
        {
          [styles.active]: grid === selectedGrid,
        }
      )}
      onClick={() => setMultiGrid(grid)}
    >
      <Text size={14} bold intl={grid} />
    </FocusableElement>
  );
}
